module.exports = __webpack_public_path__ + "static/img/052.69fad9f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fish/yqs/052.png
// module id = 1c7z
// module chunks = 0